
    import "src/app/AppAdmin/D2R/Promoter/index.module.scss?farm_css_modules";
    
    export default {"searchContainer": `searchContainer-ba1eb281`,"topHeader": `topHeader-ba1eb281`}
    